"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Oct 16 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * ThemeConverter.
 *
 * @author JMt
 */


var ThemesViewDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ThemesViewDTOConverter, _DataObjectConverter_);

  function ThemesViewDTOConverter() {
    _classCallCheck(this, ThemesViewDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ThemesViewDTOConverter).apply(this, arguments));
  }

  return ThemesViewDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ThemesViewDTOConverter = ThemesViewDTOConverter;